import React, { useState, useEffect } from 'react';
import Toggle from '../../../Global/Toggle';
import TeacherSelections from '../../../Reports/containers/TeacherSelections';
import { getUserData, setUserData } from '../../../../services/API';
import { updateBadgingConfig } from '../../../../services/amiraLicenseService';
import { TEACHER_LAYOUT } from '../../constants';
import ConfigCard from '../blocks/ConfigCard';
import { GetBrandedTutorName } from '../../../../services/BrandingService';

const selectionProps = {
  pageTitle: "Badging Configuration",
  disabledRostering: true,
};

export default function BadgingConfig(props) {

  const [badgingEnabled, setBadgingEnabled] = useState(false);

  useEffect(() => {
    const {badgingEnabled: enabled} = getUserData();
    setBadgingEnabled(enabled);
  }, [])

  return (
    <div className="reports-root-container">
        <div className="reports-page-wrap">
          <TeacherSelections
            layout={TEACHER_LAYOUT.content}
            teacherSelectionTypes={selectionProps}
            history={props.history}
            isAdminReport={true}
            containerStyle={{flex: 'unset', padding: 0}}
          />
          <div className='BadgingConfigPage'>
            <div className="configPageWrapper">
              <section className='configSection'>
                <div className='configPageSectionTitle'>ENABLE/DISABLE BADGING</div>
                <ConfigCard title='Badging Enabled'>
                  <div className='toggleConfigRow'>
                  <Toggle
                      className='teacherStyle'
                      onToggle={() => setBadgingEnabled(!badgingEnabled)}
                      leftOptionName="OFF"
                      rightOptionName="ON"
                      left={!badgingEnabled}
                    />
                    <div className='toggleConfigRowInfo'>Students will earn badges during practice with {GetBrandedTutorName()}. Teachers can award badges and create custom certificates using the Badging Report.</div>
                  </div>
                </ConfigCard>
              </section>
             
              <section className='controlBtnWrapper'>
                <div onClick={onSave} className='saveConfigBtn'>Save</div>
              </section>
            </div>
          </div>
        </div>
      </div>
  )

  async function onSave() {
    const badgingConfig = { badgingEnabled }
    const {schools, districtId} = getUserData();
    setUserData('badgingEnabled',badgingEnabled);
    updateBadgingConfig(districtId,schools,badgingConfig);
    props.history.push('/admin');
  }
}